import LogInMain from "../components/auth/LogInMain";

const LogInPage = () => {
	return <LogInMain />;
};

export default LogInPage;
